var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAqaaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.477,
    height: 216.018,
    viewBox: "0 0 226.477 216.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7959",
    "data-name": "Group 7959",
    transform: "translate(-44.166 -287.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39367",
    "data-name": "Path 39367",
    d: "M213.74,288.5,45.687,293.971l56.405,24.608,166.965-5.469Z",
    transform: "translate(0.081 0)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39368",
    "data-name": "Path 39368",
    d: "M45.666,458.674l.1-169.067,56.405,24.608V496.953Z",
    transform: "translate(0 4.364)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39369",
    "data-name": "Path 39369",
    d: "M223.866,472.622l.175-179.126L57.076,298.964V481.7Z",
    transform: "translate(45.098 19.734)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39370",
    "data-name": "Path 39370",
    d: "M45.687,298.864l56.405,29.654,166.919-9.183.046,15.421-166.965,8.389-56.405-30.4Z",
    transform: "translate(0.081 40.952)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39371",
    "data-name": "Path 39371",
    d: "M73.469,312.446v12.769l70.538-4.47v-12.2Z",
    transform: "translate(109.891 79.2)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39372",
    "data-name": "Path 39372",
    d: "M57.944,311.042,47.2,304.24v9.3l10.739,7.05Z",
    transform: "translate(6.082 62.203)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39373",
    "data-name": "Path 39373",
    d: "M62.711,313.872l-10.739-6.8v9.3l10.739,7.05Z",
    transform: "translate(24.922 73.389)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1664",
    "data-name": "Line 1664",
    y2: 9.448,
    transform: "translate(69.699 376.563)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39374",
    "data-name": "Path 39374",
    d: "M109.515,390.939l-49.3,3.805V311.292l49.3-2.011Z",
    transform: "translate(57.492 82.13)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1665",
    "data-name": "Line 1665",
    y2: 59.888,
    transform: "translate(142.355 404.415)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaaid);
export default __webpack_public_path__ + "static/media/Aqaaid.8970416ef5ad904a061600260eba8709.svg";
export { ForwardRef as ReactComponent };